// src/lib/firebase.js
// ── PASTE YOUR FIREBASE CONFIG HERE ──────────────────────────────────────
// Firebase Console → Project Settings → Your apps → Web app → Config

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBl9OvJKp53lqeczZ7zfJls1KVYbwc-m0I",
  authDomain: "practice-brain-b5606.web.app",
  projectId: "practice-brain-b5606",
  storageBucket: "practice-brain-b5606.firebasestorage.app",
  messagingSenderId: "347951199094",
  appId: "1:347951199094:web:5808003056ce3123120057"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export const getMessagingInstance = async () => {
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(app);
};

// Your org ID — set this once after creating the org in Firestore
// It's just a fixed string; everyone on your team shares it.
export const ORG_ID = "paradise-creek";

export default app;
